export default __webpack_public_path__ + "static/media/img-0761-slovenia-half-face.bed1ab7a.png";